import { ChangeDetectionStrategy, Component, ElementRef, computed, effect, input, model, viewChild } from '@angular/core';
import { ResultsStat, openResult, stepResult } from '../mon-results/results-scan';

/**
 * The post detail drawer shared by Results and Overview. Previous and Next step through `posts`,
 * in the order the opening tab gives them. Esc, the close button, or the scrim close it; ↑ and ↓ step.
 */
@Component({
  selector: 'mbtm-mon-post-drawer',
  changeDetection: ChangeDetectionStrategy.OnPush,
  templateUrl: './mon-post-drawer.html',
  styleUrl: './mon-post-drawer.scss',
})
export class MonPostDrawer {
  readonly posts = input.required<readonly ResultsStat[]>();
  readonly openedPostId = model<string | null>(null);

  private readonly dialog = viewChild<ElementRef<HTMLDialogElement>>('drawer');

  readonly opened = computed(() => {
    const id = this.openedPostId();
    return id ? openResult(this.posts(), id) : null;
  });

  constructor() {
    effect(() => {
      const dialog = this.dialog()?.nativeElement;
      if (!dialog) {
        return;
      }
      if (this.opened() && !dialog.open) {
        dialog.showModal();
      }
      if (!this.opened() && dialog.open) {
        dialog.close();
      }
    });
  }

  step(step: -1 | 1): void {
    const current = this.opened();
    if (!current) {
      return;
    }
    const next = stepResult(this.posts(), current.post.socialPostId, step);
    if (next) {
      this.openedPostId.set(next.post.socialPostId);
    }
  }

  close(): void {
    this.openedPostId.set(null);
  }

  onKeydown(event: KeyboardEvent): void {
    if (event.key !== 'ArrowDown' && event.key !== 'ArrowUp') {
      return;
    }
    event.preventDefault();
    this.step(event.key === 'ArrowDown' ? 1 : -1);
  }

  rateText(value: number | null): string {
    if (value === null) {
      return '—';
    }
    return Number.isInteger(value) ? String(value) : value.toFixed(2);
  }
}
